<template>
  <nav class="navbar navbar-expand topbar shadow d-print-none">
    <ul class="nav justify-content-center">
      <li class="nav-item">
        <router-link to="/home" title="Home">
          <span class="navbar-brand mb-0 h1">
            <img src="@/assets/img/senar.png" height="40" />
          </span>
        </router-link>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto d-none d-lg-inline">
      <li class="nav-item">
        <span class="navbar-text text-gray-600">
          <strong>Registros da Qualidade</strong>
        </span>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <p class="nav-link mb-0">
          <span class="mr-2 d-none d-sm-inline text-gray-600 small">
            {{ userName }}
          </span>
        </p>
      </li>
      <div class="topbar-divider d-none d-sm-block"></div>
      <li class="nav-item">
        <a
          role="button"
          class="nav-link text-gray-600"
          title="Sair"
          @click="logout"
        >
          Sair
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import PATHS from '@/router/routesMap'

export default {
  name: 'Navbar',

  computed: {
    userName() {
      return this.$store.getters.user.nome
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push(PATHS.BASE_URL)
      })
    },
  },
}
</script>
